import { useGetFoodSupplements } from '@/api/food-supplement/food-supplement.hooks';
import { ErrorScreen } from '@/components/ui/error-screen';
import { LoadingScreen } from '@/components/ui/loading-screen';
import { Pagination } from '@/components/ui/pagination';
import { useState } from 'react';
import { AddFoodSupplement } from './AddFoodSupplement';
import { FoodSupplementList } from './FoodSupplementList';

const ITEMS_PER_PAGE = 12;

export const FoodSupplementManagement = () => {
  const [page, setPage] = useState(1);

  const { foodSupplements, count, isLoading, isError, refetch } =
    useGetFoodSupplements({
      skip: (page - 1) * ITEMS_PER_PAGE,
      take: ITEMS_PER_PAGE,
    });

  if (isLoading) return <LoadingScreen />;
  if (isError) return <ErrorScreen />;

  return (
    <div className="container mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Compléments alimentaires</h1>
        <AddFoodSupplement refetch={refetch} />
      </div>

      {foodSupplements.length === 0 ? (
        <p className="text-gray-500 text-center mt-12">
          Aucun complément alimentaire pour le moment.
        </p>
      ) : (
        <>
          <FoodSupplementList items={foodSupplements} refetch={refetch} />
          <Pagination
            currentPage={page}
            totalItems={count}
            itemsPerPage={ITEMS_PER_PAGE}
            onPageChange={setPage}
            className="mt-4"
          />
        </>
      )}
    </div>
  );
};
